<div
  class="pm-pages-slider-container"
  #pagesSliderContainer
  (scroll)="onPageScroll()"
>
  <pm-pages-navigator
    [pages]="pages"
    #pagesNavigator
    (scrollToSlide)="scrollToSlide($event)"
  />
  @for (page of pages; track page) {
  <div class="pm-page-container" #pageContainer>
    <ng-container
      *ngTemplateOutlet="page; context: { $implicit: page }"
    ></ng-container>
  </div>
  }
</div>
